export default "__VITE_ASSET__D_2nWto3__"